import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './services/AuthContext';
import Login from './pages/Login';
import Planning from './pages/Planning';
import Dossier from './pages/Dossier';
import CompteRendu from './pages/CompteRendu';
import CompteRenduSAV from './pages/CompteRenduSAV';
import CompteRenduVT from './pages/CompteRenduVT';
import Profile from './pages/Profile';
import SAVSecteur from './pages/SAVSecteur';
import CommandeONT from './pages/CommandeONT';
import Bilan from './pages/Bilan';
import PJ from './pages/PJ';
import './index.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: 'var(--texte-doux)', fontSize: 15 }}>
      Chargement…
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/planning" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/planning" element={<PrivateRoute><Planning /></PrivateRoute>} />
          <Route path="/dossier/:id" element={<PrivateRoute><Dossier /></PrivateRoute>} />
          <Route path="/cr/:id" element={<PrivateRoute><CompteRendu /></PrivateRoute>} />
          <Route path="/cr-sav/:id" element={<PrivateRoute><CompteRenduSAV /></PrivateRoute>} />
          <Route path="/cr-vt/:id" element={<PrivateRoute><CompteRenduVT /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/sav-dispo" element={<PrivateRoute><SAVSecteur /></PrivateRoute>} />
          <Route path="/commande-ont" element={<PrivateRoute><CommandeONT /></PrivateRoute>} />
          <Route path="/bilan" element={<PrivateRoute><Bilan /></PrivateRoute>} />
          <Route path="/pj/:id" element={<PrivateRoute><PJ /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/planning" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
